// frontend/src/utils/currencyHelpers.js
import { cashierContext } from '../context/CashierContext.js';

/**
 * Formatea un monto numérico a un string de moneda, usando el símbolo correcto (USD o VES).
 * @param {number} amount - El monto a formatear.
 * @param {string} currencyCode - El código de la moneda ('USD', 'VES').
 * @returns {string} El monto formateado con su símbolo.
 */
export function formatDualCurrency(amount, currencyCode = 'USD') {
    const state = cashierContext.state;
    const amountNum = parseFloat(amount);

    if (isNaN(amountNum)) return 'N/A';

    const currencyInfo = state.availableCurrencies.find(c => c.code === currencyCode);
    const symbol = currencyInfo ? currencyInfo.symbol : (currencyCode === 'VES' ? 'Bs.' : '$');
    
    return `${symbol}${amountNum.toFixed(2)}`;
}